import dash_api from 'client/js/main/support/dash_api';
import { selectCostFileTemplateCreatorState } from 'client/js/redux/domains/CostFileTemplateCreator/CostFileTemplateCreator.selectors';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { Dispatch, RootState } from 'client/js/redux/types/redux.types';
import type { CostFileTemplate } from '../../../../../../shared/types/roi-hub/fileIngestion.types';
import { deepCopy } from '../../../../../../shared/utils';
import { CostFileTemplateAdapterService, type CostFileTemplateDto } from '../services/CostFileTemplateAdapterService';

const SUBMIT_COST_FILE_TEMPLATE_URL = '/v1/roi/cost-file-templates';

export const SUBMIT_COST_FILE_TEMPLATE = 'SUBMIT_COST_FILE_TEMPLATE' as const;

export const submitCostFileTemplate =
  () =>
  async (_: Dispatch, getState: () => RootState): Promise<CostFileTemplate> => {
    const costFileTemplateAdapter = new CostFileTemplateAdapterService();

    const state = getState();
    const costFileTemplateState = deepCopy(selectCostFileTemplateCreatorState(state));

    const payload: CostFileTemplateDto = costFileTemplateAdapter.stateToApiPayload(costFileTemplateState);

    let response;
    if (payload.id) {
      response = await dash_api.patch(`${SUBMIT_COST_FILE_TEMPLATE_URL}/${payload.id}`, payload);
    } else {
      response = await dash_api.post(SUBMIT_COST_FILE_TEMPLATE_URL, payload);
    }

    return response?.data;
  };

export type SubmitCostFileTemplateAction = DataAction<typeof SUBMIT_COST_FILE_TEMPLATE, void>;
